import { render, staticRenderFns } from "./NotificationConfirm.vue?vue&type=template&id=f2f62088&"
import script from "./NotificationConfirm.vue?vue&type=script&lang=js&"
export * from "./NotificationConfirm.vue?vue&type=script&lang=js&"
import style0 from "./NotificationConfirm.vue?vue&type=style&index=0&id=f2f62088&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports